<template>
  <div class="cutout">
    <div class="cutout__sec--top">
      <img src="/static/img/lp/cutout/01/top.jpg">
      <div class="cutout__slides">
        <swiper
          ref="mySwiper"
          :options="swiperOptions"
        >
          <swiper-slide v-for="n in 4" :key="n">
            <img :src="`/static/img/lp/cutout/01/slide${n}.png`" class="cutout__slide">
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination" slot="pagination"></div>
      </div>
    </div>
    <img src="/static/img/lp/cutout/01/point1.png" class="cutout__point1">
    <img src="/static/img/lp/cutout/01/point2.png" class="cutout__point2">
    <img src="/static/img/lp/cutout/01/point3.png" class="cutout__point3">
    <div class="cutout__sec--mark">
      <div class="cutout__sec--price">
        <img src="/static/img/lp/cutout/01/price.png" class="cutout__price">
        <link-button :link="signupUrl" class="cutout__btn cutout__btn--price" />
      </div>
      <div class="cutout__sec--special">
        <img src="/static/img/lp/cutout/01/special.png" class="cutout__special">
        <img src="/static/img/lp/cutout/01/special1.jpg" class="cutout__special1">
        <img src="/static/img/lp/cutout/01/special2.jpg" class="cutout__special2">
        <img src="/static/img/lp/cutout/01/special3.jpg" class="cutout__special3">
      </div>
    </div>
    <img src="/static/img/lp/cutout/01/voice.png" class="cutout__voice">
    <div class="cutout__sec--cta">
      <img src="/static/img/lp/cutout/01/cta.png" class="cutout__cta">
      <link-button :link="signupUrl" class="cutout__btn cutout__btn--cta" />
    </div>
  </div>
</template>

<script>
import * as types from '@/utvStore/store/mutation-types'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import FixedBackground from '@/utvStore/components/partials/FixedBackground'
import LinkButton from '@/utvStore/components/partials/LinkButton'

export default {
  name: 'Cutout01',
  components: {
    swiper,
    swiperSlide,
    LinkButton,
    FixedBackground,
  },
  props: {
    userProfile: {
      type: Object,
      default() {
        return null
      }
    }
  },
  data() {
    return {
      signupUrl: '/user/input',
      // スライドのオプション
      swiperOptions: {
        autoplay: {
          delay: 2500,
        },
        pagination: {
          el: '.swiper-pagination'
        },
      },
    }
  },
  computed: {
    // スライダー
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  created(){
    this.$store.dispatch(types.IS_LP, true)
  },
  mounted() {
    if(!!this.userProfile){
      this.signupUrl = '/subsc/join'
    }
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../sass/commons/commonVariables.scss";
.cutout {
  padding: 44px 0 10%;
  margin: -44px auto -50px;
  color: $col_base_black;
  background: url('') no-repeat center top;
  background-size: 100% auto;
  position: relative;
  img {
    vertical-align: middle;
    max-width: 100%;
  }
  &__sec--top {
    margin-bottom: 8.53%;
    position: relative;
  }
  &__slides {
    position: absolute;
    top: 56.22%;
    left: 0;
    right: 0;
  }
  &__slide {
    display: block;
    width: 89.33%;
    margin: 0 auto 2.133%;
    border-radius: unquote('min(3.2vw, 18px)');
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  }
  .swiper-pagination {
    position: static;
    /deep/ .swiper-pagination-bullet {
      width: unquote('min(2.133vw, 12px)');
      height: unquote('min(2.133vw, 12px)');
      opacity: 0.7;
      background: #fff;
      margin: 0 6px;
    }
    /deep/ .swiper-pagination-bullet-active {
      opacity: 1;
    }
  }
  &__point1,
  &__point2,
  &__point3 { margin-bottom: 21.33%;}
  &__sec--mark {
    padding: 8.53% 0 5.33%;
    margin-bottom: 10.66%;
    background: linear-gradient(86.53deg, rgba(#FF7497, 0.8) 21.4%, rgba(#CB8BFF, 0.8) 76.64%);
  }
  &__sec--price {
    position: relative;
    margin: 0 5.33% 9.55%;
  }
  &__btn {
    position: absolute !important;
    display: block !important;
    left: 0;
    right: 0;
    font-size: unquote('min(4.267vw, 25px)') !important;
    border-radius: 100px !important;
    &--price {
      top: 70%;
      width: 85.67% !important;
    }
    &--cta {
      top: 48.66%;
      width: 76.53% !important;
    }
  }
  &__sec--special {
    position: relative;
    margin: 0 0 0 2.66%;
  }
  &__special1 {
    position: absolute;
    top: 24.13%;
    left: 0;
    right: 0;
    width: 49.315%;
    margin: auto;
  }
  &__special2 {
    position: absolute;
    top: 66.66%;
    left: 10.68%;
    width: 36.71%;
    border-radius: 4px;
  }
  &__special3 {
    position: absolute;
    top: 66.66%;
    left: 50.14%;
    width: 36.71%;
    border-radius: 4px;
  }
  &__voice {
    margin-bottom: 8%;
  }
  &__sec--cta {
    padding: 0 0 0 2.66%;
    position: relative;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/lp/Cutout/01.vue